import React from 'react';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from 'react-hook-form';
import FormTextField from 'Components/FormTextField';
import ModalContent from '../ModalContent';
import { withStyles } from '@material-ui/core';
import history from '../../history';

const styles = theme => ({});

function ConfirmItemDelete({ setActiveModal, deleteItem, activeModal }) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: {},
  });

  const onSubmit = async data => {
    const itemId = activeModal.split('delete-item-')[1];
    await deleteItem(itemId);
    setActiveModal('none');
  };

  return (
    <ModalContent
      title="Are you sure?"
      buttonText="Confirm Delete"
      onFormSubmit={handleSubmit(onSubmit)}
      formContents={<p>The item can not be retrieved.</p>}
    />
  );
}

function mapStateToProps({ activeModal }) {
  return {
    activeModal,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteItem: actions.deleteItem,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(ConfirmItemDelete)),
);
